export default "__VITE_ASSET__DZjmKQFd__"